<template>
  <div>
    <div class="overflow-x-auto !rounded-b-0">
      <div class="foot-tab"
           :class="{'w-fit min-w-full' : windowWidth < 540 && (displayedTable === 'form' || displayedTable === 'full'),
            '!rounded-b-none' : variant === 'group' || noCorners, 'rounded-t-zt' : roundedTop,
            '!border-b-0 !rounded-b-[0px]' : currentSubTab === 'all'}">
        <div class="foot-tab-head"
             :class="{ 'border-b border-zt-light' : variant === 'group' }">
          <div class="foot-tab-row-label !cursor-default" :class="[{ '!w-full' : variant === 'group' },
                      window.size.mobile && (displayedTable === 'form' || displayedTable === 'full') ? '!w-[170px] shadow-[-1px_0_0_0_#3A4B64]' : '!w-[200px] xl:!w-[400px]' ]">
            <span class="underline min-w-[18px] whitespace-nowrap pl-[10px]"
                  :class="{ 'disabled-sorting' : !sorting, 'cursor-pointer zt-hover' : sorting }"
                  @click="switchSorting">
	            <span>L.p</span>
            </span>
	          <span class="underline zt-hover -translate-x-[12px] !line-clamp-1"
	                v-if="variant === 'group'"
	                :class="{ '!no-underline' : sortColumn === 'name', 'disabled-sorting pointer-events-none' : !sorting, 'cursor-pointer' : sorting }"
	                @click="sortTable('name', $event)">{{ groupTitle !== '' ? groupTitle : group.toLowerCase().replace('group', 'grupa') }}</span>
            <span class="underline zt-hover truncate"
                  v-else
                  :class="{ '!no-underline' : sortColumn === 'name' || leagueId === '253', 'disabled-sorting pointer-events-none' : !sorting || leagueId === '253',
                   'cursor-pointer' : sorting, 'pointer-events-none' : leagueId === '253' }"
                  @click="sortTable('name', $event)">{{ getTitleString(phaseString) }}</span>
          </div>
          <transition appear :name="animate ? 'fade' : ''" mode="out-in">
            <div :key="filterKey" class="flex transition">
              <div :class="{ '!no-underline' : sortColumn === 'matches', 'disabled-sorting no-sorting-row pointer-events-none' : !sorting, 'foot-tab-row-item' : sorting }"
                   @click="sortTable('matches', $event)"><div>M</div></div>
              <template v-if="displayedTable === 'full'">
                <div :class="{ '!no-underline' : sortColumn === 'goals_for', 'disabled-sorting no-sorting-row pointer-events-none' : !sorting, 'foot-tab-row-item foot-tab-row-item-family' : sorting }"
                     @click="sortTable('wins', $event)"><div>W</div></div>
                <div :class="{ '!no-underline' : sortColumn === 'goals_against', 'disabled-sorting no-sorting-row pointer-events-none' : !sorting, 'foot-tab-row-item foot-tab-row-item-family' : sorting }"
                     @click="sortTable('draws', $event)"><div>R</div></div>
                <div class="mr-3" :class="{ '!no-underline' : sortColumn === 'goal_diff', 'disabled-sorting no-sorting-row pointer-events-none' : !sorting, 'foot-tab-row-item foot-tab-row-item-family' : sorting }"
                     @click="sortTable('loses', $event)"><div>P</div></div>
              </template>
              <div :class="{ '!no-underline' : sortColumn === 'goals_for', 'disabled-sorting no-sorting-row pointer-events-none' : !sorting, 'foot-tab-row-item' : sorting }"
                   class="foot-tab-row-item-family"
                   @click="sortTable('goals_for', $event)"><div>B+</div></div>
              <div :class="{ '!no-underline' : sortColumn === 'goals_against', 'disabled-sorting no-sorting-row pointer-events-none' : !sorting, 'foot-tab-row-item' : sorting }"
                   class="foot-tab-row-item-family"
                   @click="sortTable('goals_against', $event)"><div>B-</div></div>
              <div class="mr-3 foot-tab-row-item-family" :class="{ '!no-underline' : sortColumn === 'goal_diff', 'disabled-sorting no-sorting-row pointer-events-none' : !sorting, 'foot-tab-row-item' : sorting }"
                   @click="sortTable('goal_diff', $event)"><div>RB</div></div>
              <div :class="{ '!no-underline' : sortColumn === 'points', 'disabled-sorting no-sorting-row pointer-events-none' : !sorting, 'foot-tab-row-item' : sorting }"
                   @click="sortTable('points', $event)"><div>P</div></div>
              <div v-if="displayedTable === 'form' || displayedTable === 'full'" class="foot-tab-row-item !no-underline !min-w-[165px] pointer-events-none">
                <div>Forma</div></div>
            </div>
          </transition>
        </div>
        <div class="foot-tab-row"
             :class="[!(windowWidth < 540 && (displayedTable === 'form' || displayedTable === 'full')) ? getSpotDetails(team.standings.position_details?.replaceAll(' ', '_'), index, leagueId) : '',
             { '!bg-zt-more/35' : selectedTeamsIds.includes(+team.team_id) || highlightedTeam === +team.team_id,
              '!pl-0' : window.size.mobile && (displayedTable === 'form' || displayedTable === 'full'),
               '!border-b-0' : index === leagueTable.length - 1 && (variant === 'group' || currentSubTab !== 'all') }]"
             v-for="(team, index) in leagueTable" :key="team.team_id">
          <div class="foot-tab-row-label" :class="[{ 'blur-right !w-[170px] shadow-[-1px_0_0_0_#3A4B64]' : windowWidth < 540 && (displayedTable === 'form' || displayedTable === 'full')},
          {'!bg-[#4d5a6d]' : selectedTeamsIds.includes(+team.team_id) || highlightedTeam === +team.team_id}, windowWidth < 540 && (displayedTable === 'form' || displayedTable === 'full') ? getSpotDetails(team.standings.position_details?.replaceAll(' ', '_'), index, leagueId) : '']">
            <p class="flex items-center" :class="{ '!pl-2.5 pr-1' : window.size.mobile && (displayedTable === 'form' || displayedTable === 'full') }">
              <span class="inline-block w-[22px] !shrink-0">{{isLpSet ?  leagueTable.length - index : index + 1}}.</span>
              <a v-if="redirectToTeam && (!selectedTeamsIds.includes(+team.team_id) || selectedTeamsIds.length !== 1)"
                 :data-count-click="analyticText"
                 :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null"
                 class="no-default-style flex flex-nowrap" :class="{ 'zt-hover': team.clickable }">
                <span class="flex items-center mr-2 aspect-square h-5">
                  <TeamImg :team="team"/>
                </span>
                <span class="no-default-style -ml-[3px] text-ellipsis line-clamp-1 break-all">
                  {{ team.short_name?.length > 0 ? team.short_name : team.name }}
                </span>
              </a>
              <span v-else class="flex flex-nowrap">
                <span  class="flex items-center mr-2 aspect-square h-5">
                    <TeamImg :team="team"/>
                </span>
                <span class="-ml-[3px] text-ellipsis line-clamp-1 break-all">
                  {{ team.short_name?.length > 0 ? team.short_name : team.name }}
                </span>
              </span>
              <span v-if="showPromotion && advancedTeams.includes(team.team_id)">
                <img data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-delay="1000" title="Awans"
                     class="inline ml-[5px] -translate-y-[1px] transform-gpu" :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/promotion.svg`" width="10" height="10" alt="Awans" />
              </span>
            </p>
          </div>
          <transition :name="animate ? 'fade' : ''" mode="out-in">
            <div :key="filterKey" class="flex">
              <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'matches' && sorting }">
                <div>{{ allMatches(team) }}</div>
              </div>
              <template v-if="displayedTable === 'full'">
                <div class="foot-tab-row-item foot-tab-row-item-family" :class="{ 'foot-tab-row-item-active' : sortColumn === 'wins' && sorting }">
                  <div>{{ allWins(team) }}</div>
                </div>
                <div class="foot-tab-row-item foot-tab-row-item-family" :class="{ 'foot-tab-row-item-active' : sortColumn === 'draws' && sorting }">
                  <div>{{ allDraws(team) }}</div>
                </div>
                <div class="foot-tab-row-item foot-tab-row-item-family mr-3" :class="{ 'foot-tab-row-item-active' : sortColumn === 'loses' && sorting }">
                  <div>{{ allLosses(team)}}</div>
                </div>
              </template>

              <div class="foot-tab-row-item foot-tab-row-item-family" :class="{ 'foot-tab-row-item-active' : sortColumn === 'goals_for' && sorting }">
                <div>{{ allGoals(team).split(':')[0] }}</div>
              </div>
              <div class="foot-tab-row-item foot-tab-row-item-family" :class="{ 'foot-tab-row-item-active' : sortColumn === 'goals_against' && sorting }">
                <div>{{ allGoals(team).split(':')[1] }}</div>
              </div>
              <div class="foot-tab-row-item foot-tab-row-item-family mr-3" :class="{ 'foot-tab-row-item-active' : sortColumn === 'goal_diff' && sorting }">
                <div>{{ goalDiff(team) > 0 ? '+' : '' }}{{ goalDiff(team) }}</div>
              </div>
              <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'points' && sorting }">
                <div>{{ (currentSubTab === 'all' && (displayedTable === 'all' || displayedTable === 'full')) && !(+this.leagueId === 4 || +this.leagueId === 9)
                    ? team.standings.points : getPoints(team) }}</div>
              </div>
              <div v-if="displayedTable === 'form' || displayedTable === 'full'"
                   class="min-w-[165px] text-[12px] font-semibold flex flex-nowrap gap-x-[6px] items-center justify-left leading-0 pl-[6px] xl:mx-auto">
                <a v-for="(item, index) in getFormFromFilteredMatches(team).reverse()" :href="item.link" class="zt-hover cursor pointer" target="_self"
                  data-count-click="Forma w tabeli ligowej (kwadraty WPR i klepsydra)" data-count-click-category="football"
                  :class="{'pointer-events-none': [2,3,848].includes(+this.leagueId)}">
                  <img :alt="item.text" :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/${item.text}${index === 0 ? `-first`:''}.svg`" />
                </a>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div v-if="!noFooter && currentSubTab === 'all' && (displayedTable === 'all' || displayedTable === 'full')"
         class="pl-4 py-3 bg-zt-light/35 rounded-b-zt border-[1px] border-t-[0px] border-zt-light">
      <div class="legend grid grid-cols-4 max-h-0 opacity-0 duration-500" :class="{ 'legend-full max-h-[250px] xl:max-h-[180px] opacity-100' : legendExpanded, 'overflow-hidden' : !legendExpanded }">
	      <div class="flex flex-col text-zt-more gap-y-2 text-xs col-span-4 xl:col-span-3">
        <span v-for="(detail, key, index) in details"
              class="relative before:top-[1px] before:!h-[14px] before:!rounded-zt before:!-left-2 "
              :class="getStandingsSpotDetails(key, index, 'footer')">
          {{ detail.polish_details }}
        </span>
		      <span v-if="teamsWithPenalties.length !== 0 && window.size.mobile && currentSubTab === 'all'" v-for="team in teamsWithPenalties" class="relative !text-[10px]">
          <template v-if="Number(team.standings.matches) === allMatches(team)">
              <svg class="absolute fill-zt-more w-2.5 h-2.5 !-left-3 top-[2px]" viewBox="0 0 32 32" width="20" height="20">
                <path d="M14 9.5c0-0.825 0.675-1.5 1.5-1.5h1c0.825 0 1.5 0.675 1.5 1.5v1c0 0.825-0.675 1.5-1.5 1.5h-1c-0.825 0-1.5-0.675-1.5-1.5v-1z"></path>
                <path d="M20 24h-8v-2h2v-6h-2v-2h6v8h2z"></path><path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13z"></path>
              </svg>
              {{team.shortname?.lenght > 0 ? team.shortname : team.name }}: {{team.standings.penalties}} pkt.
          </template>
        </span>
	      </div>
	      <div v-if="teamsWithPenalties.length !== 0 && window.size.desktop && currentSubTab === 'all'" class="flex flex-col text-zt-more !text-[10px] gap-y-2 text-xs col-span-2 xl:col-span-1">
		      <template v-for="team in teamsWithPenalties">
        <span v-if="Number(team.standings.matches) === allMatches(team)" class="relative">
              <svg class="absolute fill-zt-more w-2.5 h-2.5 !-left-3 top-[2px]" viewBox="0 0 32 32" width="20" height="20">
                <path d="M14 9.5c0-0.825 0.675-1.5 1.5-1.5h1c0.825 0 1.5 0.675 1.5 1.5v1c0 0.825-0.675 1.5-1.5 1.5h-1c-0.825 0-1.5-0.675-1.5-1.5v-1z"></path>
                <path d="M20 24h-8v-2h2v-6h-2v-2h6v8h2z"></path><path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13z"></path>
              </svg>
              {{team.shortname?.lenght > 0 ? team.shortname : team.name }}: {{team.standings.penalties}} pkt.
            </span>
		      </template>
	      </div>
	      <div class="col-span-4 text-zt-more text-[10px] mt-2 -ml-2" v-if="mainOrder?.length > 0 && (selectedPhase === 'Regular_Season' ||
             selectedPhase === '1st_Phase' || selectedPhase === 'Eastern_Conference' || selectedPhase === 'Western_Conference' || isLMLELKE)">
		      <span v-if="mainOrder === 'goal_diff'">O kolejności decydują: Punkty > Bilans bramek</span>
		      <span v-if="mainOrder === 'direct_matches'">O kolejności decydują: Punkty > Bilans meczów bezpośrednich</span>
	      </div>
      </div>
	    <div v-if="showLegendExpander && currentSubTab === 'all'" class="flex justify-center pt-[17px] col-span-4" :class="{ 'pt-[2px]' : !legendExpanded }">
		    <div @click="legendExpanded = !legendExpanded" class="flex items-center gap-x-[5px] cursor-pointer zt-hover">
			    <span class="text-zt-more text-xs uppercase underline">{{ legendExpanded ? 'Zwiń' : 'Rozwiń' }} legendę</span>
			    <svg class="transition" :class="{ 'rotate-180' : legendExpanded }" xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
				    <path d="M1.1972 0L5.09444 3.24417L8.9917 2.98023e-07L10.1889 0.998746L5.09444 5.24875L0 0.998746L1.1972 0Z" fill="#93A3BA"/>
			    </svg>
		    </div>
	    </div>
    </div>
  </div>
</template>

<script>

import football_mixin from '../../mixins/football_mixin';
import TeamImg from "../football_stats/blocks/TeamImg.vue";

export default {
	name: 'StandingsTable',
	components: {TeamImg},
	mixins: [football_mixin],
	props: {
    noCorners: {
      type: Boolean,
      default: false,
    },
    selectedPhase: {
      type: String,
      default: 'Regular_Season',
    },
    mainOrder: {
      type: String,
      default: '',
    },
		noFooter: {
			type: Boolean,
			default: false,
		},
		variant: {
			type: String,
			default: 'single',
		},
		group: {
			type: String,
			default: '',
		},
    phase: {
			type: String,
			default: '',
		},
		sorting: {
			type: Boolean,
			default: true,
		},
		redirectToTeam: {
			type: Boolean,
			default: true,
		},
		roundedTop: {
			type: Boolean,
			default: false,
		},
    groupTitle: {
      type: String,
      default: '',
    },
    highlightedTeam: {
      type: Number,
      default: -1,
    },
		leagueId: String,
		teams: Array,
		filters: Array,
		details: Object,
		selectedTeamsIds: {
			type: Array,
			default: [],
		},
		analyticText: {
			type: String,
			default: ''
		},
    showPromotion: {
      type: Boolean,
      default: false,
    },
    advancedTeamsIds: {
      type: Array,
      default: [],
    },
    showExpander: {
      type: Boolean,
      default: true,
    },
    animate: {
      type: Boolean,
      default: true,
    },
    view: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'compact'].includes(value);
      }
    }
	},
	data() {
		return {
			previousSortColumn: null,
			sortColumn: 'points',
			sortAscending: 0,
			currentSubTab: this.filters[this.filters.length - 1] ?? 'all',
			isLpSet: false,
      displayedTable: 'all',
      currentRoundTab: null,
      windowWidth: window.innerWidth,
      teamsWithPenalties: [],
			legendExpanded: false,
      updateNo: 0,
			hideColumns: false
    }
	},
	watch: {
		filters(newVal) {
			this.currentSubTab = newVal[this.filters.length - 1];
			if (newVal[1] && ['rounds', 'form'].includes(newVal[1]) && newVal.length !== 4 && !this.isLMLELKE) {
				return;
			}
			setTimeout(() => {
				if (newVal.length > 0) {
					this.displayedTable = newVal[1] ?? 'all';
					if (this.displayedTable !== 'all' && this.displayedTable !== 'full') {
						this.currentRoundTab = newVal[2];
						this.currentSubTab = 'all';
					} else {
						this.currentRoundTab = null;
					}
				}
			}, 200);
		},
    noOfDetails(newVal) {
      if (this.noOfDetails <= 2 || this.showExpander === false) {
        this.legendExpanded = true;
      } else {
        this.legendExpanded = false;
      }
    }
	},
	mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    })
    this.teamsWithPenalties = this.getTeamsWithPenalties();
		if (this.noOfDetails <= 2) {
			this.legendExpanded = true;
		}
	},
  updated() {
    this.updateNo += 1;
  },
  computed: {
    rowHeight() {
      return this.view === 'compact' ? '28px' : '38px';
    },
    legendBarHeight() {
      return this.view === 'compact' ? '19px' : '30px';
    },
		isLMLELKE() {
			return [2, 3, 848].includes(+this.leagueId);
		},
    filterKey() {
      if (this.filters.length === 1) {
        return this.updateNo;
      }
      return this.filters.join('-') + `-${ this.view }`;
    },
		showLegendExpander() {
			return this.noOfDetails > 2 && this.showExpander;
		},
		noOfDetails() {
			return Object.keys(this.details).length
		},
    phaseString() {
      return this.phase.replace('_', ' ');
    },
    teamsSorted() {
      if (!this.teams) {
        return [];
      }
      let teamsSort = this.teams.slice().sort(this.sortTeams);
      return teamsSort.map(team => {
        let penalties = Number(team.standings.points) - this.getPoints(team, true);
        if (penalties < 0) {
          team.standings.penalties = penalties;
        } else {
          team.standings.penalties = 0;
        }
        return team;
      });
    },
		leagueTable() {
			if (this.teamsSorted && this.teamsSorted.length > 0) {
				return this.teamsSorted.slice().sort(this.sortTeams);
			} else {
				return this.teamsSorted;
			}
		},
    advancedTeams() {
      return this.advancedTeamsIds;
    }
	},
	methods: {
    teamNextMatch(team) {
      let matches = team.matches.filter(match => {
        return ['NS', 'TBD'].includes(match.status);
      });
      if (matches.length !== 0) {
        return '/wyniki-pilka-nozna/porownanie-druzyn/' + matches[0].localteam_query + '/' + matches[0].visitorteam_query + '/'
      } else return false;
    },
		switchSorting() {
			if (!this.sorting) {
				return;
			}
			this.sortAscending = this.sortAscending === 0 ? 1 : 0;
			this.isLpSet = !this.isLpSet;
		},
    getTeamsWithPenalties() {
      return this.teamsSorted.slice().filter(team => {
        return team.standings.penalties !== 0;
      }).sort((a,b) => {
        let diff = a.penalties - b.penalties;
        if (diff !== 0) {
          return diff;
        } else {
          return a.name.localeCompare(b.name);
        }
      })
    },
		sortTeams(a, b) {
			if (!this.sorting) {
				return;
			}
			let diff = 0;
			if (this.sortColumn === 'name') {
				if (this.sortAscending) {
					diff = a.name.localeCompare(b.name);
				} else {
					diff = b.name.localeCompare(a.name);
				}
				return diff;
			}
			switch (this.sortColumn) {
				case 'matches':
					if (this.sortAscending) {
						diff = this.allMatches(a) - this.allMatches(b);
					} else {
						diff = this.allMatches(b) - this.allMatches(a);
					}
					break;
				case 'wins':
					if (this.sortAscending) {
						diff = this.allWins(a) - this.allWins(b);
					} else {
						diff = this.allWins(b) - this.allWins(a);
					}
					break;
				case 'draws':
					if (this.sortAscending) {
						diff = this.allDraws(a) - this.allDraws(b);
					} else {
						diff = this.allDraws(b) - this.allDraws(a);
					}
					break;
				case 'losses':
					if (this.sortAscending) {
						diff = this.allLosses(a) - this.allLosses(b);
					} else {
						diff = this.allLosses(b) - this.allLosses(a);
					}
					break;
				case 'points':
          if (this.currentSubTab === 'all' && (this.displayedTable === 'all' || this.displayedTable === 'full')) {
            if (this.sortAscending) {
              diff = Number(b.standings.position) - Number(a.standings.position);
            } else {
              diff = Number(a.standings.position) - Number(b.standings.position);
            }
          } else {
            if (this.sortAscending) {
              diff = this.getPoints(a) - this.getPoints(b);
              if (diff === 0) {
                diff = this.allWins(a) - this.allWins(b);
                if (diff === 0) {
                  if (this.goalDiff(a) > this.goalDiff(b)) {
                    diff = 1;
                  } else {
                    diff = -1;
                  }
                }
              }
            } else {
              diff = this.getPoints(b) - this.getPoints(a);
              if (diff === 0) {
                diff = this.allWins(b) - this.allWins(a);
                if (diff === 0) {
                  if (this.goalDiff(b) > this.goalDiff(a)) {
                    diff = 1;
                  } else {
                    diff = -1;
                  }
                }
              }
            }
          }
					break;
				case 'goals_for':
					if (this.sortAscending) {
						diff = parseInt(this.allGoals(a).split(':')[0]) - parseInt(this.allGoals(b).split(':')[0]);
					} else {
						diff = parseInt(this.allGoals(b).split(':')[0]) - parseInt(this.allGoals(a).split(':')[0]);
					}
					break;
				case 'goals_against':
					if (this.sortAscending) {
						diff = parseInt(this.allGoals(a).split(':')[1]) - parseInt(this.allGoals(b).split(':')[1]);
					} else {
						diff = parseInt(this.allGoals(b).split(':')[1]) - parseInt(this.allGoals(a).split(':')[1]);
					}
					break;
				case 'position':
					if (this.sortAscending) {
            diff = Number(a.standings.position) - Number(b.standings.position);
          } else {
            diff = Number(b.standings.position) - Number(a.standings.position);
					}
					break;
				case 'goal_diff': {
					if (this.sortAscending) {
						diff = this.goalDiff(a) - this.goalDiff(b);
					} else {
						diff = this.goalDiff(b) - this.goalDiff(a);
					}
					break;
				}
				default: {
          if (this.sortAscending) {
            diff = Number(b.standings.position) - Number(a.standings.position);
          } else {
            diff = Number(a.standings.position) - Number(b.standings.position);
          }
        }
			}
			return diff;
		},
		goalDiff(team) {
			const [bz, bs] = this.allGoals(team).split(':');
			return +bz - +bs;
		},
		avgGoals(team) {
			let allGoals = this.allGoals(team);
			let colonIndex = allGoals.indexOf(':');
			let goalsFor = parseInt(allGoals.substr(0, colonIndex));
			let goalsAgainst = parseInt(allGoals.substr(colonIndex + 1));
			let allMatches = this.allMatches(team);
			return allMatches > 0 ? ((goalsFor + goalsAgainst) / this.allMatches(team)).toFixed(1) : 0;
		},
    getStandingsSpotDetails(detail, position, type = 'table') {
      if (+this.leagueId === 40 && position === 3 && type !== 'footer')  {
        return 'foot-tab-row-marked-blue';
      }
			const detailLower = detail.toLowerCase();
      let qualifierCheckConditions = ['qualifiers', 'qualification', '(relegation)', 'relegation_playoff', 'play-off', '(relegation' , '1/16'];
      let markedBlue = ['champions_league', 'final_series', 'championship'];
			let blueExceptions = ['relegation_-_championship'];
      let markedRed = ['relegation'];
      let markedPurple = ['conference'];
      let markedGreen = ['europa_league', 'promotion'];

      let qualifier = qualifierCheckConditions.some(condition => {
        return detail.toLowerCase().includes(condition);
      }) ? '-variant' : '';
      if (markedBlue.some(condition => {return detailLower.includes(condition)})
	      && !blueExceptions.some(exc => {return detailLower.includes(exc)})) {
        return 'foot-tab-row-marked-blue' + qualifier;
      }
      if (markedPurple.some(condition => {return detailLower.includes(condition)})) {
	      qualifier = detailLower.includes('play-offs') ?  '-variant' : '';
        return 'foot-tab-row-marked-purple' + qualifier;
      }
      if (markedRed.some(condition => {return detailLower.includes(condition)})) {
        return 'foot-tab-row-marked-red' + qualifier;
      }
      if (markedGreen.some(condition => {return detailLower.includes(condition)})) {
	      if (position > 5 || (type === 'footer' && position >= 3)) {
		      return 'foot-tab-row-marked-red-variant';
	      }
        return 'foot-tab-row-marked-green' + qualifier;
      }
    },
    calculateHeadToHeadPoints(matches, team1_id, team2_id) {
    let team1Points = 0;
    let team2Points = 0;

    matches.forEach(match => {
      if (((match.localteam_id === team1_id && match.visitorteam_id === team2_id) || (match.localteam_id === team2_id && match.visitorteam_id === team1_id)) && match.status === 'FT') {
        if (match.localteam_goals > match.visitorteam_goals) {
          if (match.localteam_id === team1_id) {
            team1Points += 3;
          } else {
            team2Points += 3;
          }
        } else if (match.localteam_goals < match.visitorteam_goals) {
          if (match.localteam_id === team1_id) {
            team2Points += 3;
          } else {
            team1Points += 3;
          }
        } else {
          team1Points += 1;
          team2Points += 1;
        }
      }
    });

  return { team1Points, team2Points };
  },
	}
}

</script>
<style scoped>
.foot-tab-row-item {
  height: v-bind(rowHeight);
}

.foot-tab-row {
  height: v-bind(rowHeight);
}

.foot-tab-row-marked-red::before, .foot-tab-row-marked-red-variant::before,
.foot-tab-row-marked-blue::before, .foot-tab-row-marked-blue-variant::before,
.foot-tab-row-marked-purple::before, .foot-tab-row-marked-purple-variant::before,
.foot-tab-row-marked-green::before, .foot-tab-row-marked-green-variant::before {
  height: v-bind(legendBarHeight);
}

.blur-right {
  @apply after:content-[''] after:bg-zt-more/25 after:shadow-[1px_0_2px_0_rgba(147,163,186,0.3)] after:w-[1px] after:top-0 after:h-full after:right-[2px] after:z-20 after:absolute;
}
.disabled-sorting {
	@apply hover:cursor-default no-underline hover:brightness-100 active:brightness-100 !important;
}
.no-sorting-row {
	@apply relative h-[34px] w-[37px] grid place-items-center text-ellipsis break-all line-clamp-1 px-0.5;
}
.legend {
	transition: max-height 0.5s cubic-bezier(0, 1, 0, 1), opacity 0.2s ease-in;
}
.legend-full {
	transition: all 0.4s ease-in-out;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>